import { render, staticRenderFns } from "./IndexAsideStatic.vue?vue&type=template&id=1a3db3ff&scoped=true"
import script from "./IndexAsideStatic.vue?vue&type=script&lang=js"
export * from "./IndexAsideStatic.vue?vue&type=script&lang=js"
import style0 from "./IndexAsideStatic.vue?vue&type=style&index=0&id=1a3db3ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3db3ff",
  null
  
)

export default component.exports